// assets/custom-scripts.js

/** $(document).ready(function() {

  const accordionTabs = document.querySelectorAll('.accordion-tab');
  const accordionPanels = document.querySelectorAll('.accordion-panel');

  function closeAllPanels() {
    accordionPanels.forEach(panel => {
      panel.style.maxHeight = null;
    });
    accordionTabs.forEach(tab => {
      tab.classList.remove('active');
    });
  }

  accordionTabs.forEach(clickedTab => {
    clickedTab.addEventListener('click', function() {
      const panelId = this.getAttribute('data-target');
      const panel = document.querySelector(panelId);
      const mainPanel=document.query
      
      // Check if the clicked panel is already open
      const isAlreadyActive = this.classList.contains('active');

      // Close all panels first
      closeAllPanels();

      if (!isAlreadyActive) {
        // If it was not active, open it now
        this.classList.add('active');

        // Set max-height to its scroll height for smooth transition
        

        // --- Carousel Initialization Logic ---
        const carousel = panel.querySelector('.product-carousel');
        if (carousel && !$(carousel).hasClass('slick-initialized')) {
          $(carousel).slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true,
            responsive: [
              { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3 } },
              { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 } },
              { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
            ]
          });
        }
      }
    });
  });

}); **/
(function($) {

  $('.collapsible-title').on('click', function() {
    $(this).addClass('is-active').siblings('.collapsible-title').removeClass('is-active');
  });

})(jQuery);